export default () => (
{
  popupIsOpen: false,

  toggle() {
    this.popupIsOpen = ! this.popupIsOpen;
  },

  open() {
    this.popupIsOpen = true;
  },

  close() {
    this.popupIsOpen = false;
  },
});
